import { styled } from 'styled-components';

export const StylePhoneLoginContainer = styled.div`
  width: 100%;
`;

interface PhoneStylePhoneInputProps {
  error?: string;
  $inputFocus: boolean;
}
export const StylePhoneInputContainer = styled.div<PhoneStylePhoneInputProps>`
  border-radius: var(--pcm-rounded-lg);
  height: 47px;
  padding: 0;
  background-color: ${({ error }) => (error ? 'var(--pcm-error-background)' : 'var(--pcm-body-background-tertiary)')};
  width: 100%;
  font-size: 15px;
  font-weight: normal;
  display: flex;
  align-items: center;
  &::placeholder {
    color: var(--pcm-body-color-tertiary);
  }

  ${({ $inputFocus }) => {
    return $inputFocus ? 'outline: 1px solid var(--pcm-focus-color, var(--pcm-accent-color));' : '';
  }}
`;

export const StylePhoneInputItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 12px;

  /* .phone-input {
    flex: 1;
    height: 100%;
    padding-left: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    input {
      background-color: transparent;

      &:focus {
        outline: none;
      }
    }
  } */
`;

interface PhoneStylePhoneLabelProps {
  error?: string;
}
export const StylePhoneLabel = styled.label<PhoneStylePhoneLabelProps>`
  flex: 1;
  height: 100%;
  padding-left: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ error }) => (error ? '#EA4335' : '#000')};

  input {
    background-color: transparent;
    width: 100%;
    color: var(--pcm-body-color);
    border: none;
    &:focus,
    &:active,
    &:focus-visible {
      outline: none !important;
    }
    &::placeholder {
      color: var(--pcm-body-color-tertiary);
    }
  }
`;

export const StyleCountryBox = styled.div`
  display: flex;
  align-items: center;
`;

export const StylePrefixWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const StyleAccountSelectOpt = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  margin-right: 14px;
  * {
    font-family: system-ui !important;
  }
`;

export const StyleDownMore = styled.div`
  position: relative;
  top: 1px;
  display: flex;
  align-items: center;
`;

interface PhoneStyleCountryCodeProps {
  listposition: 'top' | 'bottom';
  $maxHeight: number;
}
export const StyleAccountSelectCountryList = styled.div<PhoneStyleCountryCodeProps>`
  position: absolute;
  z-index: 2;
  left: -1px;
  width: calc(100% + 2px);
  /* max-height: ${({ $maxHeight }) => $maxHeight || 300}px; */
  border-radius: var(--pcm-rounded-lg) !important;
  overflow: hidden;
  background-color: var(--pcm-body-background-tertiary);
  padding-top: 8px;
  color: var(--pcm-body-color);
  box-shadow: var(--pcm-modal-box-shadow);
  padding-bottom: 8px;

  /* ${({ listposition }) => (listposition === 'top' ? 'bottom: 56px;' : 'top: 20px;')} */

  &::-webkit-scrollbar {
    display: none;
    width: 0;
  }
`;

export const StyleAccountSelectCountryItem = styled.div<{ $hoverBgColor?: string }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 14px;
  font-size: 14px;
  /* position: sticky; */
  padding-top: 0px;
  padding-bottom: 0px;
  height: 46px;
  top: 0;

  cursor: pointer;

  /* &:hover {
    background-color: ${({ $hoverBgColor }) => $hoverBgColor || 'var(--pcm-body-color-tertiary)'};
  } */

  &.search-input-wrap {
    z-index: 99;
    padding: 0;
    &:hover {
      background: none !important;
    }
    .wrap {
      background: var(--pcm-body-background-tertiary);
      width: 100%;
      padding: 0 14px;
      padding-top: 4px;
      padding-bottom: 10px;
    }
  }
`;

export const StyleSearchInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 0 16px;
  border-radius: var(--pcm-rounded-lg);
  overflow: hidden;
  color: var(--pcm-body-color);
  background-color: var(--pcm-body-background);
  border: none;
  &::placeholder {
    color: var(--pcm-body-color-tertiary);
  }
`;

export const StyleCountryItem = styled.div`
  max-width: 80%;
  display: flex;
  align-items: center;
`;

export const StyleCountryFlag = styled.div`
  width: 28px;
  min-width: 28px;
  font-family: system-ui;
`;

export const StyleCountryName = styled.span`
  font-weight: 500;
  color: var(--pcm-body-color);
`;

export const StyleCountryCode = styled.div`
  color: var(--pcm-body-color-secondary);
`;

export const StyleNoData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 47px;
  color: var(--pcm-body-color-secondary);
  font-size: 12px;
`;
